import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';
import {SnackbarService} from './snackbar.service'
import {environment} from '../../environments/environment';

export interface AgreementPresignedUrl {
  url: string;
  uploadPath: string;
  fileName: string;
  contentType: string;
}

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient, private snackbarService: SnackbarService) {
  }

  getAgreementPresignedUrl(action: string, clientType: string = 'default'): Promise<AgreementPresignedUrl> {
    return firstValueFrom(
      this.http.post<{ data: AgreementPresignedUrl }>(environment.apiBaseUrl + '/admin-get-agreement-presigned-url', {action, clientType})
    ).then((res) => res.data);
  }

  async uploadToMember(file: any, action: string, clientType: string = 'default'): Promise<boolean> {
    try {
      const {url, contentType} = await this.getAgreementPresignedUrl(action, clientType);

      const response = await fetch(url, {
        method: 'PUT',
        headers: {'Content-Type': contentType},
        body: file
      });

      if (!response.ok) {
        throw new Error(`Upload failed with status ${response.status}`);
      }

      this.snackbarService.showSnackbar('Successfuly uploaded file.');
      return false;
    } catch (error: any) {
      console.error('Upload error:', error);
      this.snackbarService.handleError('Something went wrong with your upload');
      return true;
    }
  }
}
